import { makeStyles } from 'tss-react/mui';

const name = 'ChainTypeTabs';

export const useChainTypeTabsStyles = makeStyles({ name })(() => ({
  root: {
    '&': {
      // borderRadius: theme.shape.borderRadiusMd, // ex 11
    },
  },
}));
